import { FC } from "react";
import { Alert, AlertDescription, AlertIcon, AlertTitle, Box, Button, Link, Stack, Text, useToast } from "@chakra-ui/react";
import { CopyIcon, ExternalLinkIcon } from "@chakra-ui/icons";
import { copyText, detectDevice, openInSystemBrowserUrl } from "../helpers";
import { ACCENT, accentOutline } from "../accent";

const InAppBrowserWarning: FC<{ onContinue: () => void }> = ({ onContinue }) => {
  const toast = useToast()
  const isIOS = detectDevice() === "ios"
  const browser = isIOS ? "Safari" : "Chrome"
  const openUrl = openInSystemBrowserUrl()

  const handleCopy = async () => {
    const ok = await copyText(window.location.href)
    toast({
      title: ok ? "Ссылка скопирована" : "Не получилось скопировать — скопируйте адрес вручную",
      status: ok ? "success" : "warning",
      duration: 3000,
    })
  }

  return (
    <Stack spacing={4} width="100%">
      <Alert status="warning" borderRadius="md" flexDirection="column" alignItems="flex-start" gap={2}>
        <Box display="flex" alignItems="center">
          <AlertIcon />
          <AlertTitle>Откройте страницу в {browser}</AlertTitle>
        </Box>
        <AlertDescription>
          <Text>
            Вы открыли ссылку внутри мессенджера. Его встроенный браузер не умеет добавлять карты
            в {isIOS ? "Apple Wallet" : "Google Wallet"}, поэтому карта не сохранится.
          </Text>
          <Text marginTop={2}>
            {isIOS
              ? "Нажмите «⋯» или значок компаса в углу экрана и выберите «Открыть в Safari»."
              : "Нажмите «⋮» в углу экрана и выберите «Открыть в браузере» (Chrome)."}
          </Text>
        </AlertDescription>
      </Alert>
      {openUrl && (
        <Button
          as="a"
          href={openUrl}
          rightIcon={<ExternalLinkIcon />}
          textTransform="uppercase"
          colorScheme="teal"
          variant="outline"
          sx={accentOutline}
        >
          Открыть в {browser}
        </Button>
      )}
      <Button
        leftIcon={<CopyIcon />}
        textTransform="uppercase"
        colorScheme="teal"
        variant="outline"
        sx={accentOutline}
        onClick={handleCopy}
      >
        Скопировать ссылку
      </Button>
      <Text fontSize="sm" textAlign="center" color="gray.500">
        Скопируйте ссылку и вставьте её в адресную строку {browser}.{" "}
        <Link color={ACCENT} onClick={onContinue}>Всё равно продолжить здесь</Link>
      </Text>
    </Stack>
  )
}

export default InAppBrowserWarning
